import SlsClienteClient from '@/api/Cadastros/Cliente/sls-cliente.client';
import Store from '@/store';

import { ErrorMessage } from '@/libs/Error';

export default class SLSClienteService {
  constructor() {
    this.client = new SlsClienteClient();
    this.error = new ErrorMessage();
    this.store = Store;
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      const { data: datadataIndex, ...pagination } = data;
      this.store.commit('SLSCliente/SET_CLIENTES', data.data);
      this.store.commit('SLSCliente/SET_FILTERS', pagination);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os Cliente');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Cliente');
    }
  }

  async show(id) {
    try {
      return await this.client.show(id);
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Cliente');
    }
  }

  async getClienteByClientIdERP(clientIdERP) {
    try {
      return await this.client.getClienteByClientIdERP(clientIdERP);
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Cliente');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Cliente');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Cliente');
    }
  }

  async listarClienteInfoPedido(queries = this.store.getters['SLSCliente/filters']) {
    this.store.commit('SLSCliente/SET_LOADING', true);
    try {
      const params = {
        ...queries,
        representanteid: queries.representanteid
                    || this.store.getters['SLSCliente/filters'].representanteid
                    || this.store.getters['InfoPedido/GET_REPRESENTANTE_ID'],
      };

      const { data, ...pagination } = await this.client.listarClienteInfoPedido(params);
      this.store.commit('SLSCliente/SET_CLIENTES', data);
      this.store.commit('SLSCliente/SET_FILTERS', pagination);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar Cliente');
    } finally {
      this.store.commit('SLSCliente/SET_LOADING', false);
    }
  }

  async listarClientes(queries = this.store.getters['SLSCliente/filters']) {
    this.store.commit('SLSCliente/SET_LOADING', true);
    try {
      const { data, ...pagination } = await this.client.listarCliente(queries);

      this.store.commit('SLSCliente/SET_CLIENTES', data);
      this.store.commit('SLSCliente/SET_FILTERS', pagination);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar Cliente');
    } finally {
      this.store.commit('SLSCliente/SET_LOADING', false);
    }
  }

  async getInfoPedidoByClienteId(clienteId) {
    try {
      // Verifica se os dados estão em cache
      const cachedData = this.store.state.SLSCliente.cachedInfoPedidos?.[clienteId];
      if (cachedData) {
        return cachedData;
      }

      // Faz a requisição se não estiver em cache
      const data = await this.client.getInfoPedidoByClienteId(clienteId);

      // Armazena no cache
      this.store.commit('SLSCliente/SET_CACHED_INFO_PEDIDO', { clienteId, data });

      return data;
    } catch (error) {
      throw error;
    }
  }

  async listarClientePorRepresentante(representanteid, queries = {}) {
    this.store.commit('SLSCliente/SET_LOADING', true);
    try {
      const { data, ...pagination } = await this.client.listarClientePorRepresentante(representanteid, queries);
      this.store.commit('SLSCliente/SET_CLIENTES', data);
      this.store.commit('SLSCliente/SET_FILTERS', pagination);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar clientes do representante');
    } finally {
      this.store.commit('SLSCliente/SET_LOADING', false);
    }
  }

  async getInfoPedidoNovo(clienteIdERP) {
    try {
      const cachedData = this.store.state.SLSCliente.cachedInfoPedidosNovo?.[clienteIdERP];
      if (cachedData) {
        return cachedData;
      }

      const data = await this.client.getInfoPedidoNovo(clienteIdERP);

      this.store.commit('SLSCliente/SET_CACHED_INFO_PEDIDO_NOVO', { clienteIdERP, data });

      return data;
    } catch (error) {
      throw error;
    }
  }
}
